import { render, staticRenderFns } from "./BookThirdShelvesManage.vue?vue&type=template&id=6ff25dd7&scoped=true"
import script from "./BookThirdShelvesManage.vue?vue&type=script&lang=js"
export * from "./BookThirdShelvesManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff25dd7",
  null
  
)

export default component.exports